import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    wrapper: '',
    width: '',
    height: '',
    frameBorder: '0',
    attributes: {
      frameBorder: '0'
    }
  }
});
